module.exports = __webpack_public_path__ + "static/media/overview-large@2x.964c4d4c.png";